import Indicator from '../Indicator';
import subpixel from '../util/canvasSubpixelOffset';
import { types as eventTypes } from '../enums/event';

/** Region Series Indicator */
export default class RegionSeriesIndicator extends Indicator {
	/** @param {object} args Custom args*/
	constructor(args) {
		super(args);
		this.regions = [];
		this.state = { hover: false };
		this.hoverEventOver = eventTypes.INDICATOR_REGIONSERIES_MOUSE_OVER;
		this.hoverEventOut = eventTypes.INDICATOR_REGIONSERIES_MOUSE_OUT;
	}

	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'regionseries',
			name: 'Region Series',
			description: 'This indicator allows you to add a rectangular region to the chart.',
			noClip: true
		};
	}

	/** @returns {null} */
	getRangeMin() {
		return null;
	}

	/** @returns {null} */
	getRangeMax() {
		return null;
	}

	/** @returns {null} */
	_getMarkers() {
		return {};
	}

	/** @returns {null} */
	_getDataMap() {
		return null;
	}

	isWithin(mouse) {
		let regionWithin;
		this.regions.every(region => {
			if (
				mouse[0] >= region.coords.left &&
				mouse[0] < region.coords.right &&
				mouse[1] - this.panel.size.margin.top >= region.coords.top - this.params.style.margin.hover &&
				mouse[1] - this.panel.size.margin.top < region.coords.bottom + this.params.style.margin.hover
			) {
				regionWithin = region;
				return false;
			}
			return true;
		});
		return regionWithin;
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx - Chart canvas context
	 * @param {number} dateStart - Start date of region
	 * @param {number} dateStop - Stop date of region
	 * @param {string} bgColor - Background color of region
	 * @returns {undefined}
	 */
	_renderRegion(dateStart, dateStop, bgColor) {
		if (dateStart && dateStop) {
			const ctx = this.panel.rootContext;
			const minDate = new Date(dateStart);
			const maxDate = new Date(dateStop);
			const size = this.panel.size;
			const height = Math.min(this.params.style.height, size.height);
			const margin = this.params.style.margin;
			const y0 = this.params.style.align === 'top' ? margin.top : size.height - height - margin.bottom;
			const { core } = this;
			const x0 = this.xScale(core.closestExchangeIndex(minDate));
			const x1 = Math.min(
				this.xScale(core.closestExchangeIndex(maxDate)),
				size.width
			);
			if (x0 < size.width) {
				ctx.beginPath();
				ctx.fillStyle = bgColor;
				// fill
				subpixel.fillRect(ctx, x0, y0, x1 - x0 - 1, height - 2);
				// left border
				ctx.strokeStyle = this.params.style.border.left.color;
				ctx.lineWidth = 1.5;
				ctx.moveTo(x0, y0);
				ctx.lineTo(x0, y0 + height - 1);
				ctx.stroke();
				ctx.closePath();
				if (x1 >= 0) {
					return {
						left: x0,
						right: x1,
						top: y0,
						bottom: y0 + height
					};
				}
			}
		}
	}
}
